import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import ApexCharts from 'apexcharts';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements AfterViewInit {
  @ViewChild('member') memberElement!: ElementRef;
  @ViewChild('point') pointElement!: ElementRef;
  @ViewChild('coupon') couponElement!: ElementRef;
  @ViewChild('reward') rewardElement!: ElementRef;

  ngAfterViewInit(): void {
    this.MemberAllData();
    this.MemberNewData();
    this.PointData();
    this.RewardData();
    this.CouponData();

  }


  MemberAllData() {
    // var optionsSpark3 = {
    //   series: [{
    //     data: randomizeArray(sparklineData)
    //   }],
    //   chart: {
    //     type: 'area',
    //     height: 160,
    //     sparkline: {
    //       enabled: true
    //     },
    //   },
    //   stroke: {
    //     curve: 'straight'
    //   },
    //   fill: {
    //     opacity: 0.3
    //   },
    //   xaxis: {
    //     crosshairs: {
    //       width: 1
    //     },
    //   },
    //   yaxis: {
    //     min: 0
    //   },
    //   title: {
    //     text: '$135,965',
    //     offsetX: 0,
    //     style: {
    //       fontSize: '24px',
    //     }
    //   },
    //   subtitle: {
    //     text: 'Profits',
    //     offsetX: 0,
    //     style: {
    //       fontSize: '14px',
    //     }
    //   }
    // };

    // var chartSpark3 = new ApexCharts(document.querySelector("#chart-spark3"), optionsSpark3);
    // chartSpark3.render();
  }

  MemberNewData() {
    const series = {
      monthDataSeries1: {
        prices: [1, 2, 7, 4, 5, 6, 17, 1],
        dates: [
          "2023-01-01",
          "2023-01-02",
          "2023-01-03",
          "2023-01-04",
          "2023-01-05",
          "2023-01-06",
          "2023-01-07",
          "2023-01-08"
        ]
      }
    };

    const options: ApexCharts.ApexOptions = {
      series: [{
        name: "สมาชิกใหม่",
        data: series.monthDataSeries1.prices
      }],
      chart: {
        type: 'area',
        // height: 250,  // ✅ ความสูง (px)
        // width: 350,   // ✅ ความกว้าง (px)
        zoom: { enabled: false },
        toolbar: {
          show: false      // ✅ ปิด toolbar ทั้งหมด รวมถึง Download
        }
      },
      colors: ['#0E9384'], // ✅ ใส่รหัสสีที่ต้องการ (HTML Color, Hex, RGB ก็ได้)
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'straight'
      },
      title: {
        text: 'สมาชิกใหม่',
        style: {
          fontSize: '30px'
        },
        align: 'left'
      },
      // subtitle: {
      //   text: 'Price Movements',
      //   align: 'left'
      // },
      labels: series.monthDataSeries1.dates,
      xaxis: {
        type: 'datetime'
      },
      yaxis: {
        opposite: true
      },
      legend: {
        horizontalAlign: 'left'
      }
    };

    const chart = new ApexCharts(this.memberElement.nativeElement, options);
    chart.render();
  }

  PointData() {
    var options = {
      series: [44, 55],
      labels: ['คะแนนที่ออกให้ลูกค้าทั้งหมด', 'คะแนนที่ถูกใช้แล้ว'], // <-- ชื่อของแต่ละ series
      chart: {
        type: 'donut',
        height: 480
      },
      colors: ['#0E9384', '#FEB019'], // ✅ สีของแต่ละชิ้น donut (ตามลำดับ series)
      title: {
        text: 'คะแนนรวม',
        style: {
          fontSize: '30px'
        },
        align: 'left'
      },
      responsive: [{
        breakpoint: 480,
        options: {
          legend: {
            position: 'bottom'
          }
        }
      }]
    };

    var point = new ApexCharts(this.pointElement.nativeElement, options);
    point.render();
  }

  RewardData() {
    var options = {
      series: [{
        data: [400, 1380, 448]
      }],
      chart: {
        type: 'bar',
        height: 350,
        toolbar: {
          show: false      // ✅ ปิด toolbar ทั้งหมด รวมถึง Download
        }
      },
      title: {
        text: 'รางวัลที่นิยม',
        style: {
          fontSize: '30px'
        },
        align: 'left'
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          borderRadiusApplication: 'end',
          horizontal: true,
        }
      },
      dataLabels: {
        enabled: false
      },
      xaxis: {
        categories: ['ของหวานฟรี 1 ชุด', 'ส่วนลด 10 %', 'ส่วนลด 150 บาท'],
      }
    };

    var reward = new ApexCharts(this.rewardElement.nativeElement, options);
    reward.render();
  }

  CouponData() {
    var options = {
      series: [{
        data: [400, 1380, 448]
      }],
      chart: {
        type: 'bar',
        height: 350,
        toolbar: {
          show: false      // ✅ ปิด toolbar ทั้งหมด รวมถึง Download
        }
      },
      title: {
        text: 'คูปองที่นิยม',
        style: {
          fontSize: '30px'
        },
        align: 'left'
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          borderRadiusApplication: 'end',
          horizontal: true,
        }
      },
      dataLabels: {
        enabled: false
      },
      xaxis: {
        categories: ['ของหวานฟรี 1 ชุด', 'ส่วนลด 10 %', 'ส่วนลด 150 บาท'],
      }
    };

    var coupon = new ApexCharts(this.couponElement.nativeElement, options);
    coupon.render();
  }


}
